const features = [
    {
        title: "اساتید برجسته",
        listItem: [
            "با سابقه تحصیل و تدریس در بهترین دانشگاه‌های آمریکای شمالی، اروپا و ایران",
            "تعامل با بیش از ۵۰ استاد در طول دوره"
        ],
        video:
            // "https://api.derayatacademy.com/media/uploads/Brief-Teachers.mp4",
            "https://api.derayatacademy.com/media/uploads/asaatidd.mp4",
        icons: [
            // "/images/home-features-icons/slide0/1.png",
            "/images/home-features-icons/slide0/2.png",
            "/images/home-features-icons/slide0/3.png",
            "/images/home-features-icons/slide0/4.png",
            "/images/home-features-icons/slide0/5.png",
            // "/images/home-features-icons/slide0/6.png",
            "/images/home-features-icons/slide0/7.png",
            // "/images/home-features-icons/slide0/8.png",
            "/images/home-features-icons/slide0/9.png",
            "/images/home-features-icons/slide0/10.png"
        ]
    },
    {
        title: "تجربیات صنعتی",
        description:
            "بررسی تجربه مدیران شرکت‌های ایرانی و چالش‌های پیش روی آن‌ها:",
        listItem: [
            "در مدیریت سازمان‌ها",
            "پیاده‌سازی پروژه‌ها",
            "برنامه‌ریزی برای کسب و کارها"
        ],
        video:
            "https://api.derayatacademy.com/media/uploads/Brief-Industry.mp4",
        icons: [
            "/images/home-features-icons/slide1/1.png",
            "/images/home-features-icons/slide1/2.png",
            "/images/home-features-icons/slide1/3.png",
            "/images/home-features-icons/slide1/4.png",
            // "/images/home-features-icons/slide1/5.png",
            "/images/home-features-icons/slide1/6.png",
            "/images/home-features-icons/slide1/7.png",
            "/images/home-features-icons/slide1/8.png",
            "/images/home-features-icons/slide1/9.png"
        ]
    },
    {
        title: "(مطالعه موردی ) Case Study",
        listItem: [
            "رو به رو شدن با چالش‌های مدیریتی در جلسات موردکاوی",
            "تجربه تصمیم‌گیری از جایگاه مدیران شرکت‌ها",
            "بررسی تجربه شرکت‌های برتر دنیا",
            "تحلیل روندهای حاکم بر بازارها"
        ],
        // video: "https://api.derayatacademy.com/media/uploads/Brief-Case.mp4",
        video: "https://api.derayatacademy.com/media/uploads/%D9%85%D9%88%D8%B1%D8%AF%DA%A9%D8%A7%D9%88%DB%8C.mp4",
        icons: [
            "/images/home-features-icons/slide3/1.png",
            "/images/home-features-icons/slide3/2.png",
            "/images/home-features-icons/slide3/3.png",
            "/images/home-features-icons/slide3/4.png",
            "/images/home-features-icons/slide3/5.png",
            "/images/home-features-icons/slide3/6.png",
            "/images/home-features-icons/slide3/8.png",
            "/images/home-features-icons/slide3/9.png"
        ]
    },
    {
        title: "آموزش با رویکرد ترکیبی",
        icon: "/images/ico-teachers.svg",
        listItem: [
            "کلاس‌های آنلاین",
            " کنفرانس‌های زنده با اساتید بین‌المللی",
            "بحث جمعی و به اشتراک گذاری تجربه دانشجویان با یکدیگر و خبرگان صنعتی همکار",
            "کارگاه‌های تخصصی"
        ],
        video:
            // "https://api.derayatacademy.com/media/uploads/Brief-Composite.mp4",
            "",
        statistics: [
            {
                icon: "/images/statistic1.svg",
                percentage: "۴۰",
                label: "حضوری"
            },
            {
                icon: "/images/statistic2.svg",
                percentage: "۶۰",
                label: "آنلاین"
            }
        ]
    },
    {
        cards: [
            {
                title: "اساتید تراز اول دنیا",
                icon: "/images/home-features-icons/slide4/1.svg",
                text:
                    "استفاده از دانش و تجربیات اساتید با تجربه تحصیل و تدریس در بهترین دانشگاههای دنیا",
                label: "۵۲ استاد",
                color: "#00B38A",
                icons: [
                    // "/images/home-features-icons/slide4/card1/1.png",
                    "/images/home-features-icons/slide4/card1/2.png",
                    "/images/home-features-icons/slide4/card1/3.png",
                    "/images/home-features-icons/slide4/card1/4.png",
                    "/images/home-features-icons/slide4/card1/5.png",
                    "/images/home-features-icons/slide4/card1/6.png",
                    "/images/home-features-icons/slide4/card1/7.png",
                    "/images/home-features-icons/slide4/card1/8.png",
                    "/images/home-features-icons/slide4/card1/9.png"
                ]
            },
            {
                title: "تجربیات مدیران صنعت",
                icon: "/images/home-features-icons/slide4/2.svg",
                text:
                    "آشنائی با مسائل واقعی و تجربیات عملی از زبان مدیران شرکت های موفق",
                label: "۶۳ مدیر ",
                color: "#00BBCE",
                icons: [
                    "/images/home-features-icons/slide4/card2/1.png",
                    "/images/home-features-icons/slide4/card2/2.png",
                    "/images/home-features-icons/slide4/card2/3.png",
                    "/images/home-features-icons/slide4/card2/4.png",
                    "/images/home-features-icons/slide4/card2/5.png",
                    "/images/home-features-icons/slide4/card2/6.png",
                    "/images/home-features-icons/slide4/card2/7.png",
                    "/images/home-features-icons/slide4/card2/8.png",
                    "/images/home-features-icons/slide4/card2/9.png"
                ]
            },
            {
                title: "آموزش از طریق Case Study",
                icon: "/images/home-features-icons/slide4/4.svg",
                text:
                    "یادگیری از طریق تحلیل و نقد موارد واقعی در شرکت های بین المللی با استفاده از مجموعه مطالعات موردی دانشگاه هاروارد",
                label: "۳۳ شرکت",
                color: "#D85E6C",
                icons: [
                    "/images/home-features-icons/slide4/card3/1.png",
                    "/images/home-features-icons/slide4/card3/2.png",
                    "/images/home-features-icons/slide4/card3/3.png",
                    "/images/home-features-icons/slide4/card3/4.png",
                    "/images/home-features-icons/slide4/card3/5.png",
                    "/images/home-features-icons/slide4/card3/6.png",
                    "/images/home-features-icons/slide4/card3/7.png",
                    "/images/home-features-icons/slide4/card3/8.png",
                    "/images/home-features-icons/slide4/card3/9.png"
                ]
            },
            {
                title: "رویکرد ترکیبی",
                icon: "/images/home-features-icons/slide4/3.svg",
                text:
                    "تعمیق یادگیری از طریق بهره گیری متعادل از ظرفیت های آنلاین و حضوری با استفاده از ابزارهای متنوع آموزشی و تعاملات زنده و کارگاههای حضوری ",
                label: "آنلاین - حضوری",
                color: "#FFB85B",
                statistics: [
                    {
                        icon: "/images/statistic1.svg",
                        percentage: "۴۰",
                        label: "حضوری"
                    },
                    {
                        icon: "/images/statistic2.svg",
                        percentage: "۶۰",
                        label: "آنلاین"
                    }
                ]
            }
        ]
    }
];

export default features;
